import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ListView from "../../../utils/Custom/listView";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { AddButton } from "../../../utils/Custom/Button";
import { getPermissions } from "../rbac/hasAccess";

const headers = ["id", "customerName", "address", "contactPerson"];

const fields = [{ value: "customerName", label: "Customer Name" }];

const CustomerFededbackList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/customerFededback/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("customerFeedbackForm", row.id);

  const [customerFededbackListList, setCustomerFededbackList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "customerName");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      customerName: "customerName",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions = `where LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }

    return whereConditions;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`;
    }
    return `SELECT * FROM customerFeedbackForm ${whereClause} ORDER BY id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    return `SELECT COUNT(*) AS totalRows FROM customerFeedbackForm ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [customerFeedbackForm, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);
      setCustomerFededbackList(customerFeedbackForm);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching customerFeedbackForm data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/customerFededback/0"
          label="Add Customer Feedback"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        title="Search Customer Feedback"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={customerFededbackListList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
          view: (row) => navigate(`/customerFededback/print/${row.id}`),
        }}
        showCheckbox={true} //enable checkbox
        deleteTableName={"customerFeedbackForm"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default CustomerFededbackList;
